import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState<typeof categories[0] | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (cat: typeof categories[0]) => {
    setSelected(cat);
    setIsOpen(false);
    window.open(cat.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div ref={dropdownRef} className="relative w-full max-w-md">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border border-background-300/60 rounded-xl text-foreground-800 hover:border-primary-300 transition-colors duration-200 cursor-pointer text-sm"
      >
        <span className={selected ? "text-foreground-900" : "text-foreground-500"}>
          {selected ? selected.name : "Selecione uma categoria"}
        </span>
        {isOpen ? (
          <i className="ri-arrow-up-s-line text-foreground-400 transition-transform duration-200 text-lg w-5 h-5 flex items-center justify-center"></i>
        ) : (
          <i className="ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 text-lg w-5 h-5 flex items-center justify-center"></i>
        )}
      </button>
      {isOpen && (
        <div className="absolute z-50 mt-2 w-full bg-background-50 border border-background-200/70 rounded-xl shadow-lg max-h-72 overflow-y-auto">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => handleSelect(cat)}
              className="w-full flex items-center gap-3 px-5 py-3 text-left text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors duration-150 first:rounded-t-xl last:rounded-b-xl cursor-pointer"
            >
              <i className={`${cat.icon} text-lg text-foreground-400 w-5 h-5 flex items-center justify-center`}></i>
              <span className="flex-1 whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count}+</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}